export default __webpack_public_path__ + "static/media/commercial4.37bfd576.PNG";